import clsx from 'clsx';
import React, { useMemo } from 'react';
import { useControlledValue } from '../../utils';
import { Box } from '../Box';
import { HeaderCardContext } from './HeaderCardContext';
import { Text } from '../Text';
import './HeaderCard.css';
export function HeaderCard(props) {
    const { children, label, prefix, postfix, obfuscated: userObfuscated, defaultObfuscated, className, ...rest } = props;
    const [obfuscated, setObfuscated] = useControlledValue({
        value: userObfuscated,
        defaultValue: defaultObfuscated || false,
    });
    return (React.createElement(HeaderCardContext.Provider, { value: useMemo(() => ({ obfuscated, setObfuscated }), [obfuscated, setObfuscated]) },
        React.createElement(Box.Restricted, { className: clsx('mollie-ui-header-card', className), ...rest },
            prefix && React.createElement("div", { className: "mollie-ui-header-card-prefix" }, prefix),
            React.createElement("div", { className: "mollie-ui-header-card-content-wrapper" },
                label && (React.createElement(Text, { elementType: "div", variant: "caption-regular", color: "secondary", className: "mollie-ui-header-card-label" }, label)),
                React.createElement(Text, { elementType: "div", variant: "body-medium", className: clsx('mollie-ui-header-card-content', {
                        'mollie-ui-header-card-content--obfuscated': obfuscated,
                    }) }, children)),
            postfix && (React.createElement("div", { className: "mollie-ui-header-card-postfix" }, postfix)))));
}
HeaderCard.displayName = 'Header.Card';
//# sourceMappingURL=HeaderCard.js.map